import { render } from "./PromReportFollowupView.vue?vue&type=template&id=46b6bdda&scoped=true"
import script from "./PromReportFollowupView.vue?vue&type=script&lang=js"
export * from "./PromReportFollowupView.vue?vue&type=script&lang=js"

import "./PromReportFollowupView.vue?vue&type=style&index=0&id=46b6bdda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b6bdda"]])

export default __exports__